import React from "react";
import MDBox from "components/MDBox";

// Renk eşlemesi eskisiyle aynı; görünüm Finance kiti / Control Tower durum etiketiyle aynı (noktalı, dolgusuz)
const TONES = {
    success: { color: "#027A48", bg: "#ECFDF3" },
    warning: { color: "#B54708", bg: "#FFFAEB" },
    error: { color: "#B42318", bg: "#FEF3F2" },
    info: { color: "#175CD3", bg: "#EFF8FF" },
};

const getColor = (status = "") => {
    const value = String(status).toLowerCase();
    if (
        value.includes("paid") ||
        value.includes("completed") ||
        value.includes("approved") ||
        value.includes("closed")
    )
        return "success";
    if (
        value.includes("pending") ||
        value.includes("waiting") ||
        value.includes("draft") ||
        value.includes("partial")
    )
        return "warning";
    if (
        value.includes("overdue") ||
        value.includes("rejected") ||
        value.includes("cancelled") ||
        value.includes("failed")
    )
        return "error";
    return "info";
};

export default function FinanceStatusChip({ status }) {
    const tone = TONES[getColor(status)];
    return (
        <MDBox
            component="span"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.6,
                px: 1,
                py: 0.25,
                borderRadius: "6px",
                fontSize: "11.5px",
                fontWeight: 600,
                lineHeight: 1.6,
                whiteSpace: "nowrap",
                color: tone.color,
                background: tone.bg,
            }}
        >
            <MDBox component="span" sx={{ width: 6, height: 6, borderRadius: "50%", background: tone.color, flexShrink: 0 }} />
            {status}
        </MDBox>
    );
}
